import cls from './footer.module.scss';
import { Button } from 'lb-components';
import { useEffect, useState } from 'react';
import cx from 'classnames';
import { i18n, useTranslation } from 'lb-store';
import { UseUser, UseLang } from 'lb-store/src/hooks';
import _ from 'lodash';

const langOptions = { ka: 'GEO', en: 'ENG', ru: 'RUS' };
const Footer = ({ close }) => {
  const langHook = UseLang();
  const { t, i18n } = useTranslation(['main']);
  const [active, setActive] = useState(false);
  const [lang, setLang] = useState('ka');
  const { keepAlive, logout } = UseUser();

  return (
    <div className={cls.footer}>
      <div
        className={cx(cls.languageSwitcher, {
          [cls.active]: active,
        })}
        onClick={() => setActive(!active)}
      >
        <div>{langOptions[i18n.language]}</div>
        {_.map(
          _.pickBy(langOptions, (value, key) => key !== i18n.language),
          (v, k) => (
            <div key={k} onClick={() => langHook.change(k)}>
              {v}
            </div>
          )
        )}
      </div>

      <Button
        variant='danger'
        style={{
          fontSize: '2rem',
          fontWeight: 'bold',
          paddingLeft: '3rem',
          paddingRight: '3rem',
        }}
        onClick={() => {
          logout().then(() => close());
        }}
      >
        {t('გამოსვლა')}{' '}
      </Button>
    </div>
  );
};
export default Footer;
